import { Button, Col, Form, Modal, Row, Spin, message } from 'antd';
import { get } from 'lodash';
import React, { useMemo, useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { useAppContext } from '../../../common/components/appContext';
import AppLayout from '../../../common/components/layout';
import OrganisationsLookup from '../../../common/components/lookupSelect/OrganisationsLookup';
import useSkillsPermissionsContext from '../../../common/components/permissionContext/useSkillsPermissions';
import Search from '../../../common/components/search';
import useHttpHelper from '../../../common/hooks/useHttpHelper';
import { appLinks, queryKeys } from '../../../config/constants';
import CreateForm from '../create';
import EditForm from '../edit';
import Table from './table';
import useSkillFilterContext from './useSkillFilterContext';
import Dashboard from '../../../common/components/dashboard';

const pageSize = 10;

export default () => {

    const { httpPostAsync, httpPutAsync, httpDeleteAsync } = useHttpHelper();

    const { user } = useAppContext();

    const { searchParams, setSearchParams, isSearchActive, resetSearchParams } = useSkillFilterContext();

    const {
        pageNo = 0,
        query = '',
        organisationId = user.defaultOrganisationId,
        sortBy = null,
        sortOrder = null,
    } = searchParams

    //#region organsation dropdown and default value

    const onOrganisationChange = (e) => {
        try {

            console.log('organisations id', e);
            setSearchParams({ organisationId: e });

        } catch (error) {
            console.log('error on organisation change', error);
        }
    }
    //#endregion


    const fetchSkillsAsync = async () => {

        const filterParams = {
            itemPerPage: pageSize,
            organisationId: organisationId,
            query,
            pageNo,
            sortBy,
            sortOrder
        }

        console.log('fetch skills filter', filterParams)

        const response = await httpPostAsync(appLinks.adminSkills, { ...filterParams });

        console.log('fetch skills for admin', response);

        return response;
    };

    const queryKey = useMemo(() => {

        const key = [queryKeys.settingsSkillsList, organisationId, pageNo, query, sortBy, sortOrder];

        return key;

    }, [user, organisationId, query, sortBy, sortOrder, pageNo])

    const {
        isLoading,
        //isError,
        //error,
        data = [],
        isFetching,
        isPreviousData,
        refetch,
    } = useQuery(
        queryKey,
        fetchSkillsAsync,
        {
            keepPreviousData: true,
            refetchOnWindowFocus: false
        });

    let { data: skills = [], total = 0, } = data || {}

    //#region Edit TODO move to hook
    const editForm = Form.useForm();
    const [isEditVisible, setIsEditVisible] = useState(false);
    const [editSkill, setEditSkill] = useState({});

    const showEditModal = (theme) => {
        console.log('show edit modal skill', theme)
        setIsEditVisible(true);
        setEditSkill(theme)
    }

    const closeEditModal = () => setIsEditVisible(false);

    const onEditClick = () => {
        try {

            editForm[0].submit();

        } catch (error) {
            console.log('error on edit theme modal', error);
        }
    }

    const udpateSkillAsync = async (data) => {

        console.log('updated data', data);

        const link = appLinks.updateSkill.replace('{skillId}', editSkill.id);
        // console.log('accept challenge link', link);
        console.log('udpate post data', data);
        const themeData = { ...data, organisationId };
        const response = await httpPutAsync(link, themeData);
        console.log('update skill async', response);

        return response;
    };

    const editSkillId = editSkill && editSkill.id;

    const mutationQueryKey = useMemo(() => {
        return [queryKeys.updateSkill, organisationId, editSkillId]
    }, [organisationId, editSkillId])

    const {
        // data: updatePersonResponse,
        isLoading: isUpdating,
        mutateAsync: onUpdateSkillAsync,
    } = useMutation(
        udpateSkillAsync,
        { mutationKey: mutationQueryKey, }
    );

    const onUpdateAsync = async (values) => {
        try {

            console.log('on update callback', values);

            const response = await onUpdateSkillAsync(values);

            if (response.code === 0) {
                refetch();
                closeEditModal();
                message.success('Skill was updated successfully');

            } if (response && response.code !== 0) {
                message.error('Skill could not be updated');
                closeEditModal();
            }

            // console.log('updated resonse', response);

        } catch (error) {
            console.log('on update async', error);
        }
    }

    //#endregion

    //#region create theme
    const createForm = Form.useForm();
    const [isCreateVisible, setIsCreateVisible] = useState(false);

    const showCreateModal = (theme) => {
        setIsCreateVisible(true);
    }

    const closeCreateModal = () => setIsCreateVisible(false);

    const onCreateClick = () => {
        try {

            createForm[0].submit();

        } catch (error) {
            console.log('error on create theme modal submit', error);
        }
    }

    const createSkillAsync = async (data) => {

        console.log('create data', data);

        const link = appLinks.createSkill
        console.log('create skill link', link);
        console.log('create post data', data);
        const difficultyData = { ...data, organisationId };
        const response = await httpPostAsync(link, difficultyData);
        console.log('create skill async', response);

        return response;

    };

    const mutationCreateQueryKey = useMemo(() => {
        return [queryKeys.createDifficulty, organisationId]
    }, [organisationId])

    const {
        // data: updatePersonResponse,
        isLoading: isCreating,
        mutateAsync: createNewSkillAsync,
    } = useMutation(
        createSkillAsync,
        { mutationKey: mutationCreateQueryKey, }
    );

    const onCreateAsync = async (values) => {
        try {

            console.log('on create callback', values);

            const response = await createNewSkillAsync(values);

            if (response.code === 0) {
                refetch();
                closeCreateModal();
                message.success('Skill was created successfully');

            } if (response && response.code !== 0) {
                message.error('Skill could not be created');
                closeCreateModal();
            }

            console.log('updated resonse', response);

        } catch (error) {
            console.log('on update async', error);
        }
    }

    //#endregion 

    const onSortChange = (sort) => {
        try {

            console.log('sort', sort)

            const { field, order, column } = sort || {};

            if (column) {
                setSearchParams(p => ({ ...p, sortBy: field, sortOrder: order, pageNo: 0 }));
            } else {
                setSearchParams(p => ({ ...p, sortBy: null, sortOrder: null, pageNo: 0 }));
            }

        } catch (error) {
            console.log('error sorting', error);
        }
    }

    const onPagniationChange = (pagination) => {
        try {

            console.log('on change', pagination,);
            let currentPage = get(pagination, 'current');
            currentPage = currentPage > 0 ? currentPage - 1 : pageNo;
            setSearchParams(p => ({ ...p, pageNo: currentPage }));


        } catch (error) {
            console.log('error on table change', error);
        }
    }

    const styles = useMemo(() => ({
        itemStyle: {
            paddingRight: 16,
            paddingBottom: 18,
        },
        // tagsContainer: {
        //   paddingTop: tagsVisible ? 16 : 0,
        //   paddingBottom: tagsVisible ? 8 : 0

        // },
        // challengeTableContainer: {
        //   paddingTop: tagsVisible ? 0 : 17
        // }
    }), [])

    const onSearch = (e) => {
        try {
            console.log('on search list', e);
            setSearchParams(p => ({ ...p, query: e }));
        } catch (error) {
            console.log('error on search change', error);
        }
    }

    //#region delete

    const [deleteSkillId, setDeleteSkillId] = useState();

    const deleteMutationQueryKey = [queryKeys.deleteSkill, deleteSkillId]

    const deleteSkillAsync = async (skillId) => {
        try {

            const link = appLinks.deleteSkill.replace('{skillId}', skillId);
            const deleteResponse = await httpDeleteAsync(link);

            console.log('delete response', deleteResponse);

            return deleteResponse;

        } catch (error) {
            console.log('error deleting skill', error);
        }
    }

    const {
        // data: updatePersonResponse,
        isLoading: isDeleting,
        mutateAsync: onDeleteSkillAsync,
    } = useMutation(
        deleteSkillAsync,
        { mutationKey: deleteMutationQueryKey, }
    );


    const onDelete = (skillId, name) => {
        try {

            console.log('delete skill', skillId);
            Promise.resolve(setDeleteSkillId(skillId))

            Modal.confirm({
                title: `Are you sure you want to delete ${name}`,
                okText: 'Delete',
                closable: true,
                okButtonProps: {
                    loading: isDeleting,
                    disabled: isDeleting,
                },
                onOk: async () => {
                    console.log('on delete click');

                    const deleteResponse = await onDeleteSkillAsync(skillId);

                    if (deleteResponse && deleteResponse.code === 0) {
                        message.success('Skill was deleted successfully');
                    } else {
                        message.error('We are facing some issues, Skill could not be deleted');
                    }

                    await refetch();

                }

            });

        } catch (error) {
            console.log('error deleting duration', error);
        }
    }

    //#endregion

    const { 
        hasSkillsCreateAccess = false,
        hasSkillEditAccess = false,
        hasSkillsDeleteAccess = false,
    } = useSkillsPermissionsContext();

    const [resetKey, setResetKey] = useState(0);

    const onReset = () => {
        resetSearchParams();
        setResetKey(k => k + 1);
    }

    return (
        <React.Fragment>
            <Dashboard subrouting={false}  openKeys={['settings']} activeItem='settings-skills'>
                <Row justify='space-between' style={{ paddingBottom: '18px' }} gutter={24}>
                    <Col>
                        <Row>
                            <Col style={{ paddingRight: 15 }}>
                            <OrganisationsLookup
                                    mode='single'
                                    onChange={onOrganisationChange}
                                    defaultValue={organisationId}
                                    value={organisationId}
                                    style={{ width: 200 }}
                                    placeholder="Select Organisation"
                                    showSearch
                                    labelInValue={false}
                                />
                            </Col>
                            <Col style={styles.itemStyle}>
                                <Search
                                    placeholder="Search"
                                    initialValue={query}
                                    onSearch={onSearch}
                                    allowClear
                                    style={{ width: 200 }}
                                    key={resetKey}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col>
                        <Button
                            type="primary"
                            data-testid='create-skill'
                            disabled={!hasSkillsCreateAccess}
                            block
                            onClick={showCreateModal}
                        >
                            New Skill
                        </Button>
                    </Col>
                </Row>
                <Row>
                    <Col push={23}>
                        {
                            isSearchActive
                                ? (
                                    <Button type="link" size='small' onClick={onReset} style={{ marginBottom: 8 }} >
                                        Reset
                                    </Button>
                                )
                                : null
                        }
                    </Col>
                </Row>
                <Spin spinning={isLoading || isFetching}>
                    <Table
                        skills={skills}
                        showEditModal={showEditModal}
                        onPagniationChange={onPagniationChange}
                        onSortChange={onSortChange}
                        onDelete={onDelete}
                        pageNo={pageNo}
                        total={total}
                        defaultPageSize={pageSize}
                        key={resetKey}
                        sortBy={sortBy}
                        sortOrder={sortOrder}
                        hasEditAccess={hasSkillEditAccess}
                        hasDeleteAccess={hasSkillsDeleteAccess}
                    />
                </Spin>
            </Dashboard>
            <Modal
                title="Edit"
                visible={isEditVisible}
                onOk={onEditClick}
                onCancel={closeEditModal}
                okText='Save'
                okButtonProps={{
                    loading: isUpdating
                }}
                destroyOnClose
            >
                <EditForm
                    form={editForm[0]}
                    organisationId={organisationId}
                    skill={editSkill}
                    onUpdateAsync={onUpdateAsync}
                />
            </Modal>
            <Modal
                title="New"
                visible={isCreateVisible}
                onOk={onCreateClick}
                onCancel={closeCreateModal}
                okText='Save'
                okButtonProps={{
                    loading: isCreating
                }}
                destroyOnClose
            >
                <CreateForm
                    form={createForm[0]}
                    organisationId={organisationId}
                    onCreateCallback={onCreateAsync}
                />
            </Modal>
        </React.Fragment>
    )

}